function deleteCalendarForSupplies(UserInfo, Alert, filtersUtils) {
    return {
        restrict: 'AE',
        templateUrl: require('../../templates/unlink_calendar_for_supplies.html'),
        controller: function ($scope, $filter, $http, $rootScope, CalendarsMaster, CalendarForSupplyAPI) {
            /***********************************************************************************************************
            * Controller Attributes
            ***********************************************************************************************************/
            var $translate = $filter('translate');
            var self = this;
            var first_access = true;

            /***********************************************************************************************************
            * Scope Attributes
            ***********************************************************************************************************/
            $scope.flagUnlinkCalendarConfirm = false;
            $scope.listToUpdate = [];
            $scope.del_calendar = '';
            $scope.selected_del_calendar = false;

            $scope.hasPerm = UserInfo.hasPerm('calendars.delete_calendarforsupply');

            /***********************************************************************************************************
            * Scope Watchers
            ***********************************************************************************************************/
            $scope.$on("selectedItemsChange", function (e, selectedItemsChange) {
                $scope.listToUpdate = selectedItemsChange;
            });

            $scope.$on("selectedCounterChange", function (e, selectedCounterChange) {
                $scope.counter = selectedCounterChange;
            });

            $scope.$watch('deleteCalendarForm.$valid', function (newValue, oldValue) {
                $scope.$emit("setValidity", newValue);
                if (first_access == true)
                    first_access = false;
                else {
                    if (newValue)
                        $scope.selected_del_calendar = true;
                }
            }, true);

            /***********************************************************************************************************
            * Controller Methods
            ***********************************************************************************************************/
            function performRequest(ids) {
                var json = {ids: ids, calendar: $scope.del_calendar, unlink: true};

                CalendarForSupplyAPI.bulkUpdateCalendarForSupply(json)
                    .then(function (data) {
                        var message = $translate('CALENDARS.CALENDARS_UNLINK_SUCCESSFULLY') + data.num_calendars_to_delete + '. ' + $translate('CALENDARS.CALENDARS_NOT_LINK') + data.num_calendars_not_exist
                        Alert.createAlert('success', message, true);
                        $rootScope.$broadcast('refreshList');
                    }).catch(function (error) {
                        $scope.error_message = error.data.__all__[0];
                    }).finally(function () {
                        $scope.flagUnlinkCalendarConfirm = false;
                        $scope.listToUpdate = [];
                    });
            }

            /***********************************************************************************************************
            * Scope Methods
            ***********************************************************************************************************/
            $scope.clickDeleteCalendarNo = function () {
                $scope.flagUnlinkCalendarConfirm = false;
                $scope.del_calendar = '';
                $scope.selected_del_calendar = false;
            };

            $scope.clickDeleteCalendarYes = function () {
                var ids = filtersUtils.getItemsToDownloadToInt($scope.listToUpdate);
                performRequest(ids);
                $scope.del_calendar = '';
                $scope.selected_del_calendar = false;
            };

            $scope.confirmSetDelete = function () {
                $scope.flagUnlinkCalendarConfirm = true;
            };

            /***********************************************************************************************************
            * Controller Initialization
            ***********************************************************************************************************/
            CalendarsMaster.loadCalendars().then(function (response){
                $scope.calendars = response;
            });

        }
    }
}

export { deleteCalendarForSupplies };
